import { gql } from '@apollo/client';
import { eventEditableAttributes, eventListingAttributes } from './types/event';
import { eventSeriesAttributes } from './types/event-series';

const editEventSeriesAttributes = `
  ${eventSeriesAttributes}
  description
  recurringType
  monthlyRecurringType
  separationCount
  weekOfMonth
  dayOfWeek
  dayOfMonth
`;

export const convertEventToSeriesQuery = gql`
  query ConvertEventToSeriesQuery($id: ID!) {
    event(id: $id) {
      id
      ${eventEditableAttributes}
      series {
        id
      }
    }
  }
`;

export const createEventSeriesMutation = gql`
  mutation CreateEventSeriesMutation($data: NewEventSeriesInput!, $cityId: ID!, $convertEventIds: [ID]) {
    createEventSeries(data: $data, cityId: $cityId, convertEventIds: $convertEventIds) {
      id
      name
    }
  }
`;

export const updateEventSeriesMutation = gql`
  mutation CreateEventSeriesMutation($id: ID!, $data: EventSeriesInput!) {
    updateEventSeries(id: $id, data: $data) {
      ${editEventSeriesAttributes}
    }
  }
`;

export const eventSeriesConvertibleEventsQuery = gql`
  query EventSeriesConvertibleEventsQuery($hostType: EventOwnerType!, $groupId: ID) {
    eventSeriesConvertibleEvents(hostType: $hostType, groupId: $groupId) {
      id
      name
      startAt
      endAt
    }
  }
`;

export const eventSeriesLayoutQuery = gql`
  query EventSeriesLayoutQuery($id: ID!) {
    eventSeries(id: $id) {
      ${eventSeriesAttributes}
      permissions {
        editable
      }
    }
  }
`;

export const eventSeriesQuery = gql`
  query EventSeriesQuery($id: ID!) {
    eventSeries(id: $id) {
      ${eventSeriesAttributes}
      description
      recurringType
      monthlyRecurringType
      separationCount
      weekOfMonth
      dayOfWeek
      dayOfMonth
      permissions {
        editable
      }
      upcomingEvents {
        ${eventListingAttributes}
      }
      upcomingEventsCount
      pastEvents(limit: 1) {
        id
        name
        startAt
        timezone
      }
      pastEventsCount
      user {
        websiteUrl
        instagramUsername
        pastHostedEventsCount
      }
      group {
        websiteUrl
        instagramUsername
        pastEventsCount
        membersCount
      }
    }
  }
`;

export const eventSeriesPastQuery = gql`
  query EventSeriesPastQuery($id: ID!) {
    eventSeries(id: $id) {
      ${eventSeriesAttributes}
      permissions {
        editable
      }
      pastEvents {
        ${eventListingAttributes}
      }
      upcomingEventsCount
      pastEventsCount
    }
  }
`;

export const manageEventSeriesQuery = gql`
  query ManageEventSeriesQuery($id: ID!) {
    eventSeries(id: $id) {
      ${editEventSeriesAttributes}
      upcomingEventsCount
      upcomingEvents {
        id
        ${eventEditableAttributes}
      }
      pastEvents {
        id
        name
        startAt
        endAt
        timezone
      }
      scheduleDates(count: 12)
      permissions {
        editable
      }
    }
  }
`;

export const eventSeriesIndexQuery = gql`
  query MyEventSeriesQuery {
    me {
      id
      eventSeries {
        ${eventSeriesAttributes}
        description
        recurringType
        monthlyRecurringType
        separationCount
        weekOfMonth
        dayOfWeek
        dayOfMonth
        upcomingEventsCount
        upcomingEvents(limit: 1) {
          id
          startAt
          endAt
          timezone
        }
      }
      groups {
        id
        name
        slug
        eventSeries {
          ${eventSeriesAttributes}
          description
          recurringType
          monthlyRecurringType
          separationCount
          weekOfMonth
          dayOfWeek
          dayOfMonth
          upcomingEventsCount
          upcomingEvents(limit: 1) {
            id
            startAt
            endAt
            timezone
          }
        }
      }
    }
  }
`;
